import { render, staticRenderFns } from "./QuestDoctor.vue?vue&type=template&id=15cdcc7a&scoped=true&"
import script from "./QuestDoctor.ts?vue&type=script&lang=ts&"
export * from "./QuestDoctor.ts?vue&type=script&lang=ts&"
import style0 from "./QuestDoctor.scss?vue&type=style&index=0&id=15cdcc7a&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "15cdcc7a",
  null
  
)

export default component.exports